function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import filter from 'lodash/filter';
import findIndex from 'lodash/findIndex';
import get from 'lodash/get';
import sortBy from 'lodash/sortBy';
import unionBy from 'lodash/unionBy';
import uniq from 'lodash/uniq';
import isEqual from 'lodash/isEqual';
import { registerAction, unregisterAction } from 'helpers/reducerTools';
import * as actionTypes from './actionTypes';
const initialState = {
    phiSet: null,
    phiSetDocumentId: null,
    batchesIndex: [],
    cgmBatchesIndex: [],
    notesBatchesIndex: [],
    readings: [],
    highlightedReadings: [],
    relatedData: [],
    timeSeriesResources: [],
    cgmReadings: [],
    notes: [],
    sharingRequests: [],
    beingApprovedSharingRequestId: null,
    familyLinkInvitations: [],
    familyLinkRequests: [],
    activeFamilyLink: null,
    fetching: [],
    sending: [],
    errors: [],
    measurements: [],
    measurementsBatchesIndex: [],
    isMyDoctorsPageInitialized: false
};
const readingUnion = (reading)=>`${reading.deviceSerialNumberToken}_${reading.timestamp}`;
const measurementUnion = (measurement)=>`${measurement.deviceSerialNumberToken}_${measurement.timestamp}_${measurement.type}`;
export default function reducer(state = _object_spread({}, initialState), action = {}) {
    switch(action.type){
        case actionTypes.SET_PHI_SET:
            {
                const { phiSet, phiSetDocumentId } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    phiSet,
                    phiSetDocumentId
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SET_READINGS:
            {
                const { phiSet, readings, batchesIndex, cgmReadings, cgmBatchesIndex, relatedData, timeSeriesResources, measurements, measurementsBatchesIndex } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    phiSet,
                    batchesIndex: uniq([
                        ...state.batchesIndex,
                        ...batchesIndex
                    ]),
                    cgmBatchesIndex: uniq([
                        ...state.cgmBatchesIndex,
                        ...cgmBatchesIndex
                    ]),
                    measurementsBatchesIndex: uniq([
                        ...state.measurementsBatchesIndex,
                        ...measurementsBatchesIndex
                    ]),
                    readings: sortBy(unionBy(state.readings, readings, readingUnion), [
                        'timestamp'
                    ]),
                    cgmReadings: sortBy(unionBy(state.cgmReadings, cgmReadings, readingUnion), [
                        'timestamp'
                    ]),
                    measurements: sortBy(unionBy(state.measurements, measurements, measurementUnion), [
                        'timestamp'
                    ]),
                    relatedData: unionBy(relatedData, state.relatedData, 'readingId'),
                    timeSeriesResources: sortBy(unionBy(state.timeSeriesResources, timeSeriesResources, 'id'), [
                        'timestamp'
                    ])
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SET_NOTES:
            {
                const { phiSet, phiSetDocumentId, notes, notesBatchesIndex } = action.payload;
                const stateUpdate = {
                    notes: sortBy(unionBy(notes, state.notes, 'noteId'), [
                        'timestamp'
                    ]),
                    notesBatchesIndex: uniq([
                        ...state.notesBatchesIndex,
                        ...notesBatchesIndex
                    ])
                };
                if (phiSetDocumentId !== state.phiSetDocumentId) {
                    stateUpdate.phiSet = phiSet;
                    stateUpdate.phiSetDocumentId = phiSetDocumentId;
                }
                return _object_spread({}, state, stateUpdate);
            }
        case actionTypes.CLEAR_NOTES_BATCHES:
            {
                return _object_spread_props(_object_spread({}, state), {
                    notesBatchesIndex: []
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SET_IMPORTED_READINGS:
            {
                const { phiSet, phiSetDocumentId, readings, cgmReadings } = action.payload;
                const { summaryData: { totalReadingsCount = 0 } = {} } = phiSet;
                const { summaryData: { totalReadingsCount: oldTotalReadingsCount = 0 } = {} } = state.phiSet;
                const areNewReadings = oldTotalReadingsCount !== totalReadingsCount;
                const newReadings = readings.filter((payloadReading)=>!state.readings.some((reading)=>isEqual(`${reading.deviceSerialNumberToken}_${reading.timestamp}`, `${payloadReading.deviceSerialNumberToken}_${payloadReading.timestamp}`)));
                return _object_spread_props(_object_spread({}, state), {
                    phiSet,
                    phiSetDocumentId,
                    readings: sortBy(unionBy(state.readings, newReadings, readingUnion), [
                        'timestamp'
                    ]),
                    cgmReadings: sortBy(unionBy(state.cgmReadings, cgmReadings, readingUnion), [
                        'timestamp'
                    ]),
                    highlightedReadings: areNewReadings ? sortBy(unionBy(state.highlightedReadings, newReadings, readingUnion), [
                        'timestamp'
                    ]) : state.highlightedReadings
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SET_IMPORTED_MEASUREMENTS:
            {
                const { phiSet, phiSetDocumentId, measurements } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    phiSet,
                    phiSetDocumentId,
                    measurements
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SET_SHARING_REQUEST:
            {
                const { sharingRequest } = action.payload;
                const sharingRequests = [
                    ...state.sharingRequests
                ];
                const idx = findIndex(sharingRequests, {
                    sharingRequestId: sharingRequest.sharingRequestId
                });
                if (idx >= 0) {
                    sharingRequests[idx] = sharingRequest;
                } else {
                    sharingRequests.push(sharingRequest);
                }
                return _object_spread_props(_object_spread({}, state), {
                    sharingRequests
                });
            }
        case actionTypes.UNSET_SHARING_REQUEST:
            {
                const { sharingRequest } = action.payload;
                const sharingRequests = filter(state.sharingRequests, (sr)=>sr.sharingRequestId !== sharingRequest.sharingRequestId);
                return _object_spread_props(_object_spread({}, state), {
                    sharingRequests
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SET_BEING_APPROVED_SHARING_REQUEST_ID:
            {
                const { beingApprovedSharingRequestId } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    beingApprovedSharingRequestId
                });
            }
        case actionTypes.UNSET_BEING_APPROVED_SHARING_REQUEST_ID:
            {
                return _object_spread_props(_object_spread({}, state), {
                    beingApprovedSharingRequestId: null
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.FETCH_SHARING_REQUESTS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.FETCH_SHARING_REQUESTS),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_SHARING_REQUESTS)
                });
            }
        case actionTypes.FETCH_SHARING_REQUESTS_SUCCESS:
            {
                const { sharingRequests } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    sharingRequests,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_SHARING_REQUESTS)
                });
            }
        case actionTypes.FETCH_SHARING_REQUESTS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_SHARING_REQUESTS),
                    errors: registerAction(state.errors, actionTypes.FETCH_SHARING_REQUESTS)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.ENROLL_IN_CLINIC:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.ENROLL_IN_CLINIC),
                    errors: unregisterAction(state.errors, actionTypes.ENROLL_IN_CLINIC)
                });
            }
        case actionTypes.ENROLL_IN_CLINIC_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.ENROLL_IN_CLINIC)
                });
            }
        case actionTypes.ENROLL_IN_CLINIC_ERROR:
            {
                const { sharingRequest } = action.payload;
                const sharingRequests = sharingRequest ? [
                    ...state.sharingRequests,
                    sharingRequest
                ] : state.sharingRequests;
                return _object_spread_props(_object_spread({}, state), {
                    sharingRequests,
                    sending: unregisterAction(state.sending, actionTypes.ENROLL_IN_CLINIC),
                    errors: registerAction(state.errors, actionTypes.ENROLL_IN_CLINIC)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.APPROVE_SHARING_REQUEST:
            {
                const sharingRequestId = get(action.payload, 'sharingRequest.sharingRequestId');
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, `${actionTypes.APPROVE_SHARING_REQUEST}-${sharingRequestId}`),
                    errors: unregisterAction(state.errors, `${actionTypes.APPROVE_SHARING_REQUEST}-${sharingRequestId}`)
                });
            }
        case actionTypes.APPROVE_SHARING_REQUEST_SUCCESS:
            {
                const { sharingRequest } = action.payload;
                const { sharingRequestId } = sharingRequest;
                const sharingRequests = [
                    ...state.sharingRequests
                ];
                const idx = findIndex(sharingRequests, {
                    sharingRequestId
                });
                if (idx >= 0) {
                    sharingRequests[idx] = sharingRequest;
                } else {
                    sharingRequests.push(sharingRequest);
                }
                return _object_spread_props(_object_spread({}, state), {
                    sharingRequests,
                    sending: unregisterAction(state.sending, `${actionTypes.APPROVE_SHARING_REQUEST}-${sharingRequestId}`)
                });
            }
        case actionTypes.APPROVE_SHARING_REQUEST_ERROR:
            {
                const sharingRequestId = get(action.payload, 'sharingRequest.sharingRequestId');
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, `${actionTypes.APPROVE_SHARING_REQUEST}-${sharingRequestId}`),
                    errors: registerAction(state.errors, `${actionTypes.APPROVE_SHARING_REQUEST}-${sharingRequestId}`)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.REVOKE_SHARING_REQUEST:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.REVOKE_SHARING_REQUEST),
                    errors: unregisterAction(state.errors, actionTypes.REVOKE_SHARING_REQUEST)
                });
            }
        case actionTypes.REVOKE_SHARING_REQUEST_SUCCESS:
            {
                const { sharingRequest } = action.payload;
                const sharingRequests = filter(state.sharingRequests, (sr)=>sr.sharingRequestId !== sharingRequest.sharingRequestId);
                return _object_spread_props(_object_spread({}, state), {
                    sharingRequests,
                    sending: unregisterAction(state.sending, actionTypes.REVOKE_SHARING_REQUEST)
                });
            }
        case actionTypes.REVOKE_SHARING_REQUEST_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.REVOKE_SHARING_REQUEST),
                    errors: registerAction(state.errors, actionTypes.REVOKE_SHARING_REQUEST)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.INVITE_FAMILY_MEMBERS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.INVITE_FAMILY_MEMBERS),
                    errors: unregisterAction(state.errors, actionTypes.INVITE_FAMILY_MEMBERS)
                });
            }
        case actionTypes.INVITE_FAMILY_MEMBERS_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.INVITE_FAMILY_MEMBERS)
                });
            }
        case actionTypes.INVITE_FAMILY_MEMBERS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.INVITE_FAMILY_MEMBERS),
                    errors: registerAction(state.errors, actionTypes.INVITE_FAMILY_MEMBERS)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.FETCH_FAMILY_SHARING_LINKS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.FETCH_FAMILY_SHARING_LINKS),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_FAMILY_SHARING_LINKS)
                });
            }
        case actionTypes.FETCH_FAMILY_SHARING_LINKS_SUCCESS:
            {
                const { familyLinkInvitations, familyLinkRequests } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    familyLinkInvitations,
                    familyLinkRequests,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_FAMILY_SHARING_LINKS)
                });
            }
        case actionTypes.FETCH_FAMILY_SHARING_LINKS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_FAMILY_SHARING_LINKS),
                    errors: registerAction(state.errors, actionTypes.FETCH_FAMILY_SHARING_LINKS)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.FETCH_FAMILY_SHARING_LINK_REQUESTS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.FETCH_FAMILY_SHARING_LINK_REQUESTS),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_FAMILY_SHARING_LINK_REQUESTS)
                });
            }
        case actionTypes.FETCH_FAMILY_SHARING_LINK_REQUESTS_SUCCESS:
            {
                const { familyLinkRequests } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    familyLinkRequests,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_FAMILY_SHARING_LINK_REQUESTS)
                });
            }
        case actionTypes.FETCH_FAMILY_SHARING_LINK_REQUESTS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_FAMILY_SHARING_LINK_REQUESTS),
                    errors: registerAction(state.errors, actionTypes.FETCH_FAMILY_SHARING_LINK_REQUESTS)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.REVOKE_FAMILY_ACCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.REVOKE_FAMILY_ACCESS),
                    errors: unregisterAction(state.errors, actionTypes.REVOKE_FAMILY_ACCESS)
                });
            }
        case actionTypes.REVOKE_FAMILY_ACCESS_SUCCESS:
            {
                const { familyLink } = action.payload;
                const { familyLinkId } = familyLink;
                const familyLinkInvitations = [
                    ...state.familyLinkInvitations
                ];
                const idx = findIndex(familyLinkInvitations, {
                    familyLinkId
                });
                if (idx < 0) {
                    return _object_spread_props(_object_spread({}, state), {
                        sending: unregisterAction(state.sending, actionTypes.REVOKE_FAMILY_ACCESS)
                    });
                }
                familyLinkInvitations.splice(idx, 1);
                return _object_spread_props(_object_spread({}, state), {
                    familyLinkInvitations,
                    sending: unregisterAction(state.sending, actionTypes.REVOKE_FAMILY_ACCESS)
                });
            }
        case actionTypes.REVOKE_FAMILY_ACCESS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.REVOKE_FAMILY_ACCESS),
                    errors: registerAction(state.errors, actionTypes.REVOKE_FAMILY_ACCESS)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.ACTIVATE_FAMILY_MEMBER:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.ACTIVATE_FAMILY_MEMBER),
                    errors: unregisterAction(state.errors, actionTypes.ACTIVATE_FAMILY_MEMBER)
                });
            }
        case actionTypes.ACTIVATE_FAMILY_MEMBER_SUCCESS:
            {
                const { activeFamilyLink } = action.payload;
                if (state.activeFamilyLink && activeFamilyLink.familyLinkId === state.activeFamilyLink.familyLinkId) {
                    return _object_spread_props(_object_spread({}, state), {
                        fetching: unregisterAction(state.fetching, actionTypes.ACTIVATE_FAMILY_MEMBER)
                    });
                }
                return _object_spread_props(_object_spread({}, state), {
                    activeFamilyLink,
                    phiSet: null,
                    phiSetDocumentId: null,
                    batchesIndex: [],
                    cgmBatchesIndex: [],
                    readings: [],
                    cgmReadings: [],
                    relatedData: [],
                    fetching: unregisterAction(state.fetching, actionTypes.ACTIVATE_FAMILY_MEMBER)
                });
            }
        case actionTypes.ACTIVATE_FAMILY_MEMBER_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.ACTIVATE_FAMILY_MEMBER),
                    errors: registerAction(state.errors, actionTypes.ACTIVATE_FAMILY_MEMBER)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.DEACTIVATE_FAMILY_MEMBER:
            {
                return _object_spread_props(_object_spread({}, state), {
                    activeFamilyLink: null,
                    phiSet: null,
                    phiSetDocumentId: null,
                    phiSetPatientId: null,
                    sharingRequest: null,
                    batchesIndex: [],
                    cgmBatchesIndex: [],
                    readings: [],
                    cgmReadings: [],
                    relatedData: []
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SYNC:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.SYNC),
                    errors: unregisterAction(state.errors, actionTypes.SYNC)
                });
            }
        case actionTypes.SYNC_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.SYNC)
                });
            }
        case actionTypes.SYNC_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.SYNC),
                    errors: registerAction(state.errors, actionTypes.SYNC)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.ON_STORE_READINGS_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.ON_STORE_READINGS_SUCCESS),
                    errors: unregisterAction(state.errors, actionTypes.ON_STORE_READINGS_SUCCESS)
                });
            }
        case actionTypes.ON_STORE_READINGS_SUCCESS_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.ON_STORE_READINGS_SUCCESS)
                });
            }
        case actionTypes.ON_STORE_READINGS_SUCCESS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.ON_STORE_READINGS_SUCCESS),
                    errors: registerAction(state.errors, actionTypes.ON_STORE_READINGS_SUCCESS)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SET_IMPORTED_RELATED_DATA:
            {
                const { phiSet, phiSetDocumentId, relatedData } = action.payload;
                relatedData.map((item)=>{
                    const oldRelatedData = state.relatedData.find((stateItem)=>stateItem.readingId === item.readingId);
                    if (oldRelatedData) {
                        item.activities = unionBy(item.activities, oldRelatedData.activities, (activity)=>activity.id).filter((activities)=>!activities.isDelete);
                        item.foods = unionBy(item.foods, oldRelatedData.foods, (food)=>`${food.id}_${food.name}`).filter((foods)=>!foods.isDelete);
                        item.medications = unionBy(item.medications, oldRelatedData.medications, (medication)=>`${medication.id}_${medication.name}`).filter((medications)=>!medications.isDelete);
                    }
                    return item;
                });
                return _object_spread_props(_object_spread({}, state), {
                    phiSet,
                    phiSetDocumentId,
                    relatedData: unionBy(relatedData, state.relatedData, 'readingId')
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.REAUTH_CONTOUR_CLOUD:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.REAUTH_CONTOUR_CLOUD),
                    errors: unregisterAction(state.errors, actionTypes.REAUTH_CONTOUR_CLOUD)
                });
            }
        case actionTypes.REAUTH_CONTOUR_CLOUD_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.REAUTH_CONTOUR_CLOUD)
                });
            }
        case actionTypes.REAUTH_CONTOUR_CLOUD_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.REAUTH_CONTOUR_CLOUD),
                    errors: registerAction(state.errors, actionTypes.REAUTH_CONTOUR_CLOUD)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.INITIALIZE_MY_DOCTORS_PAGE:
            {
                return _object_spread_props(_object_spread({}, state), {
                    isMyDoctorsPageInitialized: false,
                    fetching: registerAction(state.fetching, actionTypes.INITIALIZE_MY_DOCTORS_PAGE),
                    errors: unregisterAction(state.errors, actionTypes.INITIALIZE_MY_DOCTORS_PAGE)
                });
            }
        case actionTypes.INITIALIZE_MY_DOCTORS_PAGE_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    isMyDoctorsPageInitialized: true,
                    fetching: unregisterAction(state.fetching, actionTypes.INITIALIZE_MY_DOCTORS_PAGE)
                });
            }
        case actionTypes.INITIALIZE_MY_DOCTORS_PAGE_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.INITIALIZE_MY_DOCTORS_PAGE),
                    errors: registerAction(state.errors, actionTypes.INITIALIZE_MY_DOCTORS_PAGE)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        default:
            {
                return state;
            }
    }
}
